import { FC } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo';
import ScrollToTop from '@/components/shared/ScrollToTop/ScrollToTop.tsx';

const BrandedSimple: FC = () => {
  return (
    <div className="flex flex-col grow min-h-screen justify-between gap-8 lg:gap-12">
      <ScrollToTop />
      <header id="app-header" className="flex justify-center pt-8 md:pt-16 lg:pt-24 px-8">
        <Link to={Routes.DASHBOARD}>
          <AppLogo.Default className="w-[320px] max-w-full" />
        </Link>
      </header>
      <main id="app-main" className="flex grow">
        <Outlet />
      </main>
      <footer id="app-footer" className="flex pt-8 md:pt-16 lg:pt-24">
        <AppLogo.Default className="w-[320px] max-w-full opacity-0" />
      </footer>
    </div>
  );
};

export default BrandedSimple;
